import { Container, AppBar, Paper, Box, Modal, Button, Toolbar, Typography, TextField } from "@mui/material";
import React from "react";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddReligion() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [newReligion, setNewReligion] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  let navigate = useNavigate();
  const handleCancel = () => {
    setNewReligion("");
  }

  const handleSave = async () => {
    try {

      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Religion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          religionName: newReligion,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setLoadingBarProgress(100);

        // Check status field or keywords in message for failures
        const errorKeywords = ['already exist', 'failed', 'error', 'unable', 'cannot'];
        const messageHasError = errorKeywords.some(k => responseData.msg && responseData.msg.toLowerCase().includes(k));

        if (responseData.status && responseData.status.toLowerCase().includes('failed')) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else if (messageHasError) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'The Religion has been added successfully.');
        }

        setModalOpen(true);
        if (!messageHasError && (!responseData.status || !responseData.status.toLowerCase().includes('failed'))) {
          setNewReligion('');
        }
      } else {
        setLoadingBarProgress(0);
        // alert('Failed to save religion');
        setSnackbarMessage('Failed to save religion');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      // alert('API request error:', error);
      setSnackbarMessage('API request error:', error);
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };
  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Religion
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <div
          className="row g-3 align-items-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: '100%',
          }}
        >
          <div class="col-md-8" style={{ width: '100%', }}>

            <TextField
              fullWidth
              label="Religion Name"
              id="religionName"
              sx={{ marginBottom: 3 }}
              value={newReligion}
              required
              onChange={(e) => setNewReligion(e.target.value)}
            />

          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{ mx: 1 }}
            disabled={!newReligion} onClick={handleSave}>
            <b>SAVE</b>
          </Button>
          <Button
            variant="contained"
            color="error"


            onClick={handleCancel}
          >
            <b>RESET</b>
          </Button>
        </div>
      </Paper>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1); // go back after closing modal
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default AddReligion;